import { render, staticRenderFns } from "./MpnBasicButton.vue?vue&type=template&id=20209077&"
import script from "./MpnBasicButton.vue?vue&type=script&lang=js&"
export * from "./MpnBasicButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports